import axiosInstance from '../plugins/axios'
import { provide } from 'vue'

// @ts-ignore
const assetsUrl = import.meta.env.VITE_CLIENT_ASSETS_URL

export const getTheme = async () => {
  console.log('getTheme')
}

export const applyAdditionalSettings = async (settingsWithoutCssType: any) => {
  const styleElement = document.getElementById('dynamic-styles')

  settingsWithoutCssType.forEach((setting: any) => {
    if (setting.key == 'socialLinksEnabled') {
      styleElement?.insertAdjacentHTML(
        'beforeend',
        `.socialLinks { display: ${setting.value ? 'block' : 'none'}; }`
      )
    }
    if (setting.key == 'backgroundCanvasVisible') {
      styleElement?.insertAdjacentHTML(
        'beforeend',
        `.backgroundCanvas { display: ${setting.value ? 'block' : 'none'}; }`
      )
    }
    if (setting.key === 'frameworkLogo') {
      styleElement?.insertAdjacentHTML(
        'beforeend',
        `.logo-container { 
                    background-image: url('${setting.value}'); 
                    background-size: contain; 
                    background-repeat: no-repeat; 
                    background-position: center;
                    width: 120px;
                    height: 120px; 
                    }`
      )
    }

    if (setting.key === 'linkedinLink') {
      provide('linkedinLink', setting.value)
    }

    if (setting.key === 'backgroundImage') {
      styleElement?.insertAdjacentHTML(
        'beforeend',
        `.global-styling { 
              background-image: url('${assetsUrl}${setting.value}') !important; 
              background-size: cover; 
              background-repeat: no-repeat; 
              background-position: center;
              }`
      )
    }

    // Bold Font for strong, b, etc..
    if (setting.key === 'boldFont') {
      if (setting.value === 'Automatic Bold Styling') {
      styleElement?.insertAdjacentHTML(
        'beforeend',
        `
      strong, b, .bold, .fw-bold {
        font-family: inherit !important;
        font-weight: bold !important;
      }
      `
      )
      } else {
      styleElement?.insertAdjacentHTML(
        'beforeend',
        `
      strong, b, .bold, .fw-bold {
        font-family: '${setting.value}' !important;
        font-weight: normal !important;
      }
      `
      )
      }
    }
  })
}

export const generateCSS = async (styles: Record<string, any>) => {
  const existingStyleElement = document.getElementById('dynamic-styles')
  if (existingStyleElement) {
    existingStyleElement.remove()
  }

  const styleElement = document.createElement('style')
  styleElement.id = 'dynamic-styles'
  styleElement.type = 'text/css'

  const settingsWithoutCssType: Record<string, any>[] = []

  styleElement.textContent = Object.entries(styles)
    .map(([key, value]) => {
      if (value.cssType === 'additionalSetting' || !value.cssType) {
        settingsWithoutCssType.push(value)
        return ''
      }

      const cssValue = typeof value.value === 'object' ? JSON.stringify(value.value) : value.value

      const rawCssClass = value.cssClass
      let cssClasses: string[] = []

      if (Array.isArray(rawCssClass)) {
        cssClasses = rawCssClass
      } else if (typeof rawCssClass === 'string') {
        try {
          cssClasses =
            rawCssClass.startsWith('[') && rawCssClass.endsWith(']')
              ? JSON.parse(rawCssClass.replace(/'/g, '"'))
              : [rawCssClass]
        } catch (e) {
          console.error('Invalid cssClass format:', rawCssClass, e)
          return ''
        }
      }

      return cssClasses
        .map((cssClass) => `${cssClass.trim()} { ${value.cssType}: ${cssValue} !important; }`)
        .join('\n')
    })
    .filter(Boolean)
    .join('\n')

  if (styleElement.textContent.trim()) {
    document.head.appendChild(styleElement)
  }

  if (settingsWithoutCssType.length > 0) {
    return settingsWithoutCssType
  }
}
